module.exports = __webpack_public_path__ + "fonts/NotoSansGeorgian-SemiBold.451a41b0.woff2";